import { bus } from "@/main";

export default {
	name: "LoadingScreen",
	data() {
		return {
			error: false,
		}
	},
	props: {
	},
	created() {
		bus.$on("apiError", (error) => {
			console.error("ERROR:", error)
			this.error = true;
		});
	},
	watch: {
	},
	computed: {},
	mounted() {},
	methods: {
	}
}



// WEBPACK FOOTER //
// ./src/components/blocks/loading-screen/loading.screen.js